export default "__VITE_ASSET__urk9IysD__"